import { clsx } from "clsx";

export default function IconFloor({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("", className)}
    >
      <path
        d="M15 3V7H11V11H7V15H3V21H5V17H9V13H13V9H17V5H21V3H15ZM16 12L17.7917 13.7917L12.0208 19.5625L13.4375 20.9792L19.2083 15.2083L21 17V12H16Z"
        fill="#151922"
      />
    </svg>
  );
}
